import tailwindTheme from "../../../tailwind.theme.config.js";

window.tailwindConfig = tailwindTheme;

window.tailwindConfig.get = function (key) {
    return window.tailwindConfig.extend[key];
}

window.tailwindConfig.themeColors = function (key) {
    return window.tailwindConfig.extend.colors[key];
}